export default __webpack_public_path__ + "static/media/saludproxapps.a695b411.svg";